import { useState, useEffect } from 'react';
import './Blog.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Form from '../../components/Form';
import Image2 from './image2.jpg';

const BlogPage = () => {
  const navigate = useNavigate();
  const [isFormOpen, setFormOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  return (
    <div className='page'>
      <Header onFormClick={() => setFormOpen(true)} />
      <div className='blogPageHeaderContent'>
        <div className='blogPageHeader'>
          <span className='blogPageHeaderBack' onClick={() => navigate('/blog')}>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path
                d='M12 0C14.3734 0 16.6934 0.703788 18.6668 2.02236C20.6402 3.34094 22.1783 5.21508 23.0865 7.4078C23.9948 9.60051 24.2324 12.0133 23.7694 14.3411C23.3064 16.6689 22.1635 18.807 20.4853 20.4853C18.807 22.1635 16.6689 23.3064 14.3411 23.7694C12.0133 24.2324 9.60051 23.9948 7.4078 23.0865C5.21508 22.1783 3.34094 20.6402 2.02236 18.6668C0.703787 16.6934 0 14.3734 0 12C0.00335884 8.81843 1.26872 5.76814 3.51843 3.51843C5.76814 1.26872 8.81843 0.00335979 12 0ZM6.73154 12.6531L10.4238 16.3454C10.597 16.5186 10.832 16.6159 11.0769 16.6159C11.3219 16.6159 11.5568 16.5186 11.73 16.3454C11.9032 16.1722 12.0005 15.9373 12.0005 15.6923C12.0005 15.4474 11.9032 15.2124 11.73 15.0392L9.61269 12.9231H16.6154C16.8602 12.9231 17.095 12.8258 17.2681 12.6527C17.4412 12.4796 17.5385 12.2448 17.5385 12C17.5385 11.7552 17.4412 11.5204 17.2681 11.3473C17.095 11.1742 16.8602 11.0769 16.6154 11.0769H9.61269L11.73 8.96077C11.9032 8.78756 12.0005 8.55264 12.0005 8.30769C12.0005 8.06274 11.9032 7.82782 11.73 7.65461C11.5568 7.48141 11.3219 7.3841 11.0769 7.3841C10.832 7.3841 10.597 7.48141 10.4238 7.65461L6.73154 11.3469C6.64571 11.4326 6.57763 11.5345 6.53117 11.6465C6.48472 11.7586 6.46081 11.8787 6.46081 12C6.46081 12.1213 6.48472 12.2414 6.53117 12.3535C6.57763 12.4655 6.64571 12.5673 6.73154 12.6531Z'
                fill='#2C2B46'
              />
            </svg>
            Back to Articles
          </span>
        </div>
        <div className='blogPageImage'>
          <img src={Image2} />
        </div>
        <div className='blogPageDetails'>
          <span className='blogPageAuthor'>Richard Nguyen • October 5, 2025</span>
          <span className='blogPageTime'>3 min</span>
        </div>
        <h2 className='blogPageTitle'>AI Can Find Matches. Humans Create Meaning.</h2>
        <div className='blogPageText'>
          OpenAI just dropped plans for a new AI-powered jobs platform, a bold move into the hiring space. It promises to match
          companies and candidates using AI, and to lean heavily on AI fluency and skills certification.
          <br />
          <br />
          Sounds futuristic, right? But here’s what this really means for recruiting and where humans still hold the edge:
          <br />
          <ul className='blogPageList'>
            <li className='blogPageListItem'>
              <strong>AI can match keywords. Humans match people.</strong>
              <br />
              The new platform might help with volume. But it won’t feel the hesitation in someone’s voice, see the cultural
              misalignment, or catch subtle red flags. That’s where real recruiters win.
            </li>
            <li className='blogPageListItem'>
              <strong>AI finds patterns. Humans build trust.</strong>
              <br />
              Connections, context, relationships. These don’t come from algorithms. They come from conversations, follow-through,
              and integrity.
            </li>
            <li className='blogPageListItem'>
              <strong>AI helps scale operations. Humans scale outcomes.</strong>
              <br />
              As business goals shift, strategies shift. AI helps with consistency. But a recruiter recalibrates with you, shifts
              priorities, and customizes hiring on the fly.
            </li>
          </ul>
          <br />
          At NextDeavor, this is exactly how we lean in. We use AI to streamline the routine. But we hire (and train) people to do
          the important stuff: the meaning-making, the bridge-building, the human alignment.
          <br />
          <br />
          So yes, OpenAI entering the hiring space raises the bar. It challenges us all to be sharper, more intentional, more
          human.
          <br />
          <br />
          But if you ever think AI is going to fully replace recruiters… I think you’re missing the big picture.
        </div>
      </div>

      <Footer />
      {isFormOpen && <Form onClose={() => setFormOpen(false)} />}
    </div>
  );
};

export default BlogPage;
